import React from 'react'
import ReactLoading from 'react-loading';
import writtenNumber from 'written-number'
import _ from 'lodash'

export class ColumnSummation extends React.Component {
  render() {

    let data = this.props.data
    let sumof = this.props.sumof
    if(data.length > 0) {
      let total = _.sum(_.map(data, d=>{
        return parseFloat(d[sumof])
      }))

      total = parseFloat(total).toFixed(2)

      return <div className="text-right">
        {total}
      </div>
    }
    else {
      return null
    }

  }
}

function checkGstn(gst) {

    var factor = 2,
        sum = 0,
        checkCodePoint = 0,
        i, j, digit, mod, codePoint, cpChars, inputChars;
    cpChars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    inputChars = gst.trim().toUpperCase();

    mod = cpChars.length;
    for (i = inputChars.length - 1; i >= 0; i = i - 1) {
        codePoint = -1;
        for (j = 0; j < cpChars.length; j = j + 1) {
            if (cpChars[j] === inputChars[i]) {
                codePoint = j;
            }
        }

        digit = factor * codePoint;
        factor = (factor === 2) ? 1 : 2;
        digit = (digit / mod) + (digit % mod);
        sum += Math.floor(digit);
    }
    checkCodePoint = ((mod - (sum % mod)) % mod);

    return gst + cpChars[checkCodePoint];
};

function gstin(gst) {
    var GstinPttn = /[0-9]{2}[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9A-Za-z]{1}[Zz1-9A-Ja-j]{1}[0-9a-zA-Z]{1}/;
    if (testPattern(gst, GstinPttn)) {
        var substrgst = gst.substr(0, 14);
        if (gst === checkGstn(substrgst)) {
            return true;
        }
    }
    return false;
};
function uin(uin) {
    var UinPttn = /[0-9]{4}[A-Z]{3}[0-9]{5}[UO]{1}[N][A-Z0-9]{1}/;
    if (testPattern(uin, UinPttn)) {
        var substrgst = uin.substr(0, 14);
        if (uin === checkGstn(substrgst)) {
            return true;
        }
    }
    return false;
};
function testPattern(iString, iPattern) {
    var patt = new RegExp(iPattern),
        isPatternValid = patt.test(iString);
    return isPatternValid;
}

export function validateGSTIN(ctin, iForm) {
    var validGstin = false;
    if (iForm === 'GSTR1')
        validGstin = gstin(ctin) || uin(ctin);
    else
        validGstin = gstin(ctin);

    return validGstin;

}
export function inWords(n) {
  var nums = n.toString().split('.')

  var whole = writtenNumber(nums[0], {lang:"enIndian", noAnd:true})

  if (nums.length === 2 && parseFloat(nums[1])>0  ) {
      var fraction = writtenNumber(nums[1])
      return <div className="">
          <span></span>
          <span className="text-capitalize">{whole + ' rupees'}</span>
          <span>{' and '}</span>
          <span className="text-capitalize">{fraction + ' paise Only'}</span>
      </div>

  } else {
    return <div>
       <span></span>
       <span className="text-capitalize">{whole + ' rupees only'}</span>
   </div>

  }

}



Number.prototype.round = function(p) {
    p = p || 10;
    return parseFloat( this.toFixed(p) );
};

export function round(number, precision) {

  return  parseFloat(parseFloat(number).toFixed(precision))
}


export function removeZeros(before){

    if(typeof before === "string") {
      if(before.endsWith('.')) {
        return before
      }
      else if(before.length ===0) {
        return ""
      }
      else {
        return parseFloat(before)
      }
    }
    else {
      return parseFloat(before)
    }

}

 const Loading = ({ type, color }) => (
    <ReactLoading type={'spin'} color={'#77A4F1'} height={64} width={64} className='component-loading' />
);

export class Loader extends React.Component {


  render() {

    // If loading defined and it is true
    if(typeof this.props.loading !== "undefined" && this.props.loading) {
        return <Loading />
    }
    else if (typeof this.props.loading !== "undefined") {
      // loading defined but not loading
        return null
    }
    else {
      return <Loading />
    }


  }
}



// WEBPACK FOOTER //
// ./src/utils/misc.js